export default __webpack_public_path__ + "9876345dd98879c046d6a4da49220125.svg";